import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      // Navigation
      nav: {
        home: 'Accueil',
        about: 'À propos',
        services: 'Services',
        projects: 'Projets',
        contact: 'Contact',
      },
      // Hero Section
      hero: {
        tagline: 'Innovation Technologique',
        title: "L'avenir de la",
        titleHighlight: 'technologie',
        titleEnd: 'commence ici',
        subtitle: 'Med Stud Tech conçoit et développe des solutions innovantes dans les domaines du médical, de la finance, de l\'automatisme, des systèmes de gestion et de l\'IA. Nous transformons vos idées en technologies performantes.',
        cta: 'Collaborer',
        ctaSecondary: 'Découvrir',
      },
      // About Section
      about: {
        label: 'À propos',
        title: 'Notre Vision',
        titleHighlight: 'du Futur',
        description: 'Med Stud Tech est une entreprise spécialisée dans l\'informatique, la programmation et l\'innovation technologique. Nous imaginons, créons et réinventons les technologies de demain.',
        vision: {
          title: 'Vision',
          text: 'Devenir un acteur majeur de l\'innovation technologique, en créant des solutions qui transforment les industries de la santé et de la finance.',
        },
        mission: {
          title: 'Mission',
          text: 'Accompagner les entrepreneurs et les entreprises dans la réalisation de leurs projets technologiques les plus ambitieux.',
        },
        values: {
          title: 'Valeurs',
          text: 'Innovation, Excellence, Intégrité et Collaboration sont les piliers de notre engagement envers nos partenaires.',
        },
      },
      // Services Section
      services: {
        label: 'Nos Services',
        title: 'Solutions',
        titleHighlight: 'Innovantes',
        subtitle: 'Une expertise complète pour donner vie à vos projets les plus ambitieux.',
        items: {
          mobile: {
            title: 'Applications Mobiles',
            description: 'Développement sur-mesure d\'applications iOS et Android. De la conception UX jusqu\'au déploiement sur les stores.',
          },
          medical: {
            title: 'Solutions Médicales',
            description: 'Télémédecine, gestion de dossiers patients, dispositifs connectés. Des outils pensés pour les professionnels de santé.',
          },
          finance: {
            title: 'Solutions Financières',
            description: 'Paiements sécurisés, tableaux de bord analytiques, gestion de portefeuille. La fintech au service de votre croissance.',
          },
          automation: {
            title: 'Automatisation',
            description: 'Automatisez vos processus métier : workflows, RPA, intégrations API. Gagnez en efficacité au quotidien.',
          },
          management: {
            title: 'Systèmes de Gestion',
            description: 'ERP, CRM, outils collaboratifs sur-mesure. Des systèmes adaptés à votre organisation et vos équipes.',
          },
          ai: {
            title: 'Intelligence Artificielle',
            description: 'Machine learning, traitement du langage, vision par ordinateur. L\'IA au service de vos enjeux business.',
          },
          entrepreneurs: {
            title: 'Accompagnement Startups',
            description: 'Du MVP au scale-up : conseil technique, architecture, recrutement. On vous accompagne à chaque étape.',
          },
        },
      },
      // Projects Section
      projects: {
        label: 'Innovation & Projets',
        title: 'Nos',
        titleHighlight: 'Réalisations',
        subtitle: 'Découvrez nos projets innovants qui façonnent l\'avenir de la technologie.',
      privacyLink: 'Politique de confidentialité',
        items: {
          mediconnect: {
            title: 'Radioclinic',
            category: 'Santé',
            description: 'Application d\'aide à la décision médicale dans l\'imagerie et la radiologie : radios, échographies, IRM. L\'IA assiste les praticiens dans l\'analyse et le diagnostic.',
          },
          fintrack: {
            title: 'KIMIA',
            category: 'Finance',
            description: 'Solution de paiement complète : terminaux CB/Visa/Mastercard/Mobile Money, gestion des stocks, prédiction des ruptures par IA, analyse de consommation client. Idéal pour indépendants et commerces.',
          },
          healthdata: {
            title: 'Sanitar',
            category: 'R&D',
            description: 'Plateforme de prévention des épidémies analysant en temps réel les données médicales. Prédictions et simulations intégrant la météo locale pour anticiper les risques sanitaires.',
          },
          smartpay: {
            title: 'SmartPay Wallet',
            category: 'Fintech',
            description: 'Portefeuille numérique nouvelle génération avec authentification biométrique avancée.',
          },
        },
        rnd: {
          title: 'R&D & Technologies du Futur',
          description: 'Notre équipe de recherche explore constamment les nouvelles frontières technologiques : Intelligence Artificielle, Blockchain, IoT médical et bien plus encore.',
        },
      },
      // Contact Section
      contact: {
        label: 'Contact',
        title: 'Travaillons',
        titleHighlight: 'Ensemble',
        subtitle: 'Prêt à transformer vos idées en réalité ? Contactez-nous pour discuter de votre projet.',
        form: {
          name: 'Nom complet',
          email: 'Adresse email',
          phone: 'Téléphone',
          subject: 'Sujet',
          message: 'Votre message',
          submit: 'Envoyer le message',
          sending: 'Envoi en cours...',
          success: 'Message envoyé avec succès !',
          error: 'Erreur lors de l\'envoi. Veuillez réessayer.',
        },
        legal: {
          title: 'Mentions Légales',
          company: 'Med Stud Tech',
          address: 'Adresse',
          siren: 'SIREN',
          siret: 'SIRET (siège)',
        },
      },
      // Footer
      footer: {
        tagline: 'Transformer les idées en technologies du futur.',
        rights: 'Tous droits réservés.',
        links: {
          privacy: 'Confidentialité',
          terms: 'Conditions',
          legal: 'Mentions légales',
        },
      },
    },
  },
  en: {
    translation: {
      // Navigation
      nav: {
        home: 'Home',
        about: 'About',
        services: 'Services',
        projects: 'Projects',
        contact: 'Contact',
      },
      // Hero Section
      hero: {
        tagline: 'Technological Innovation',
        title: 'The future of',
        titleHighlight: 'technology',
        titleEnd: 'starts here',
        subtitle: 'Med Stud Tech designs and develops innovative solutions in medical, finance, automation, management systems and AI. We transform your ideas into high-performance technologies.',
        cta: 'Collaborate',
        ctaSecondary: 'Discover',
      },
      // About Section
      about: {
        label: 'About Us',
        title: 'Our Vision',
        titleHighlight: 'for the Future',
        description: 'Med Stud Tech is a company specialized in IT, programming and technological innovation. We imagine, create and reinvent tomorrow\'s technologies.',
        vision: {
          title: 'Vision',
          text: 'To become a major player in technological innovation, creating solutions that transform healthcare and finance industries.',
        },
        mission: {
          title: 'Mission',
          text: 'To support entrepreneurs and businesses in achieving their most ambitious technological projects.',
        },
        values: {
          title: 'Values',
          text: 'Innovation, Excellence, Integrity and Collaboration are the pillars of our commitment to our partners.',
        },
      },
      // Services Section
      services: {
        label: 'Our Services',
        title: 'Innovative',
        titleHighlight: 'Solutions',
        subtitle: 'Full-stack expertise to bring your most ambitious projects to life.',
        items: {
          mobile: {
            title: 'Mobile Applications',
            description: 'Custom iOS and Android development. From UX design to app store deployment.',
          },
          medical: {
            title: 'Medical Solutions',
            description: 'Telemedicine, patient records, connected devices. Tools designed for healthcare professionals.',
          },
          finance: {
            title: 'Financial Solutions',
            description: 'Secure payments, analytics dashboards, portfolio management. Fintech powering your growth.',
          },
          automation: {
            title: 'Automation',
            description: 'Automate your business processes: workflows, RPA, API integrations. Boost your daily efficiency.',
          },
          management: {
            title: 'Management Systems',
            description: 'Custom ERP, CRM, collaborative tools. Systems tailored to your organization and teams.',
          },
          ai: {
            title: 'Artificial Intelligence',
            description: 'Machine learning, NLP, computer vision. AI solutions for your business challenges.',
          },
          entrepreneurs: {
            title: 'Startup Support',
            description: 'From MVP to scale-up: technical consulting, architecture, hiring. We support you every step.',
          },
        },
      },
      // Projects Section
      projects: {
        label: 'Innovation & Projects',
        title: 'Our',
        titleHighlight: 'Achievements',
        subtitle: 'Discover our innovative projects shaping the future of technology.',
      privacyLink: 'Privacy Policy',
        items: {
          mediconnect: {
            title: 'Radioclinic',
            category: 'Healthcare',
            description: 'Medical decision support application for imaging and radiology: X-rays, ultrasounds, MRIs. AI assists practitioners in analysis and diagnosis.',
          },
          fintrack: {
            title: 'KIMIA',
            category: 'Finance',
            description: 'Complete payment solution: CB/Visa/Mastercard/Mobile Money terminals, inventory management, AI-powered stock prediction, customer consumption analysis. Ideal for independents and shops.',
          },
          healthdata: {
            title: 'Sanitar',
            category: 'R&D',
            description: 'Epidemic prevention platform analyzing medical data in real-time. Predictions and simulations integrating local weather to anticipate health risks.',
          },
          smartpay: {
            title: 'SmartPay Wallet',
            category: 'Fintech',
            description: 'Next-generation digital wallet with advanced biometric authentication.',
          },
        },
        rnd: {
          title: 'R&D & Future Technologies',
          description: 'Our research team constantly explores new technological frontiers: Artificial Intelligence, Blockchain, Medical IoT and much more.',
        },
      },
      // Contact Section
      contact: {
        label: 'Contact',
        title: 'Let\'s Work',
        titleHighlight: 'Together',
        subtitle: 'Ready to transform your ideas into reality? Contact us to discuss your project.',
        form: {
          name: 'Full name',
          email: 'Email address',
          phone: 'Phone number',
          subject: 'Subject',
          message: 'Your message',
          submit: 'Send message',
          sending: 'Sending...',
          success: 'Message sent successfully!',
          error: 'Error sending message. Please try again.',
        },
        legal: {
          title: 'Legal Information',
          company: 'Med Stud Tech',
          address: 'Address',
          siren: 'SIREN',
          siret: 'SIRET (headquarters)',
        },
      },
      // Footer
      footer: {
        tagline: 'Transforming ideas into tomorrow\'s technologies.',
        rights: 'All rights reserved.',
        links: {
          privacy: 'Privacy',
          terms: 'Terms',
          legal: 'Legal',
        },
      },
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
